<template>
    <div class="mycoupon-container flexC">
        <div class="tabs-container">
            <van-tabs v-model="tabsActive" line-width="1.2rem" line-height="0.2rem" @change="tabChange" class="mytabswz" color="#FF5252"	title-inactive-color="#303133" title-active-color="#FF5252">
                <van-tab title="未使用" name="0"></van-tab>
                <van-tab title="已使用" name="1"></van-tab>
                <van-tab title="已过期" name="2"></van-tab>
            </van-tabs>
        </div>
        <div class="content-container">
            <div class="item-courtesy  flexC" :class="'received-item'+tabsActive" v-for="(item,index) in couponList" :key="index">
                <div class="item-left flexC">
                    <div class="courtesy-money" :class="(typeof item.discount === 'number')&&(item.discount+'').length>3?'maxMonery':''">
                        <p class="moeny-num"><span>¥</span>{{item.discount}}</p>
                        <p class="condition">
                            {{item.thresholdType == 162002?'满'+item.thresholdMoney+'元可使用':$t("shop.noSill")}}
                        </p>
                    </div>
                    <div class="hr-line"></div>
                    <div class="courtesy-info-text">
                        <p class="name">{{item.name}}</p>
                        <p class="expiration-date">有效期至{{item.validEt}}</p>
                    </div>
                    <i class="used-icon" v-if="tabsActive == 1"></i>
                </div>
                <div class="item-right  flexC" >
                    <span>
                        {{tabsActive == 0?'已领取':tabsActive == 1?'已使用':'已过期'}}
                    </span>
                </div>
            </div>
            <div class="nodata" v-if="couponList.length==0">
                <img src="@/assets/img/data-null.png" >
            </div>
        </div>
    </div>
</template>

<script>
import { CouponQuery } from "@/api/user";
export default {
    data () {
        return {
            tabsActive:"0",
            couponList:[]
        }
    },
    created () {
        this.getCouponData();  
    },
    methods: {
        getCouponData(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            let datadd = {};
            if(this.tabsActive == 0){
                datadd.isUsed = 0;
            }else if(this.tabsActive == 1){
                datadd.isUsed = 1;
            }else if(this.tabsActive == 2){
                datadd.isExpired = 1; 
            }
            CouponQuery(datadd).then(result=>{
                toast.clear();
                if(result.data.errorCode == 0){
                    this.couponList = result.data.data;
                }
            })
        },
        tabChange(){
            this.getCouponData();
        }
    }
}
</script>

<style lang="less" scoped>
.mycoupon-container{
    height: 100%;
    flex-direction: column;
    background: #F5F6FA;
    .tabs-container{
        flex: 0 0 auto;
        width: 100%;
        /deep/ .mytabswz {
            .van-tabs__wrap{
                height: 2rem;
                .van-tab__text{
                    font-size: 0.6rem;
                    font-weight: 400;
                    height: max-content;
                    line-height: initial;
                }
                .van-tabs__nav {
                    // padding: 0 0.6rem;
                }
            }
            .van-tab{
                border-bottom: 0.04rem solid #F5F6FA;
                &:first-child{
                    margin-left: 0.6rem;
                }
                &:nth-child(2){
                    margin-right: 0.6rem;
                }
            }
            .van-tabs__content{
                background: #FFFFFF;
            }
        }
    }
    .content-container{
        flex: 1;
        width: 100%;
        overflow: auto;
        padding: 0 0.6rem 1rem 0.6rem;
        box-sizing: border-box;
        .item-courtesy{
            margin-top: 0.6rem;
            overflow: auto;
            position: relative;
            &>div{
                float: left;
            }
            .item-left{
                z-index: 2;
                margin-right: 1.4rem;
                width: calc(100% - 1.6rem);
                background: #FFFFFF;
                padding:0 0.4rem;
                position: relative;
                border-radius: 0.64rem;
                &::after,&::before{
                    width: 0.8rem;
                    height: 0.8rem;
                    position: absolute;
                    display: block;
                    content: ' ';
                    border-radius: 50%;
                    top: 50%;
                    transform: translate(0,-50%);
                }
                &::after{
                    background: #F5F6FA;
                    left: -0.4rem;
                }
                &::before{
                    background: #F9B4B7;
                    right: -0.4rem;
                }
                .courtesy-money{
                    flex: 0 0 auto;
                    width: 3.8rem;
                    box-sizing: border-box;
                    background-position: center;
                    text-align: center;
                    padding: 0.6rem 0.4rem 0.6rem 0;
                    background: url("~@/assets/img/money-bg-icon.png") no-repeat;
                    background-size: auto 100%;
                    .moeny-num{
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 600;
                        color: #FF5252;
                        font-size: 1.4rem;
                        span{
                            font-size: 0.64rem;
                        }
                    }
                    .condition{
                        font-size: 0.4rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FF5252;
                    }
                }
                .courtesy-money.maxMonery{
                    width: max-content;
                }
                .courtesy-info-text{
                    padding: 0 0.7rem;
                    .name{
                        font-size: 0.6rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #303133;
                        line-height: 0.8rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;				//溢出内容隐藏
                        text-overflow: ellipsis;		//文本溢出部分用省略号表示
                        display: -webkit-box;			//特别显示模式
                        -webkit-line-clamp: 2;			//行数
                        line-clamp: 2;					
                        -webkit-box-orient: vertical;	//盒子中内容竖直排列
                    }
                    .expiration-date{
                        font-size: 0.4rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #909399;
                        margin-top: 0.2rem;
                        line-height: 0.56rem;
                    }
                }
                .hr-line{
                    width: 0;
                    height: 2rem;
                    border-left: 0.02rem solid #909399;
                }
            }
            .item-right{
                right: 0;
                width: 4rem;
                border-radius: 0.64rem;
                position: absolute;
                height: 100%;
                background: #F9B4B7;
                margin-left: -2rem;
                z-index: 1;
                justify-content: flex-end;
                span{
                    font-size: 0.48rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    width: 0.5rem;
                    margin-right: 0.45rem;
                }
            }
        }
        .received-item1{
            .item-left{
                position: relative;
                .used-icon{
                    position: absolute;
                    width: 2.04rem;
                    height: 2.04rem;
                    display: block;
                    background: url("~@/assets/img/used-icon.png") no-repeat;
                    background-size: 100% 100%;
                    right: 0.8rem;
                    bottom: 0.6rem;
                }
            }
        }
    }
}
.nodata{
    height: 96%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 8rem;
    }
}
</style>